export function isExitCommand(value: string) {
	return value.trim().toLowerCase() === '/exit';
}

export type { ChatCommand as DialogCommand } from '@/shared/ui/chat/commands';
